import React, { useState } from 'react';
import './PDFViewer.css';

const PDFModal = ({ pdfUrl, title, onClose }) => (
  <div className="pdf-modal-overlay" onClick={onClose}>
    <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="pdf-modal-header">
        <h3>{title}</h3>
        <button className="pdf-modal-close" onClick={onClose}>×</button>
      </div>
      <div className="pdf-modal-body">
        <iframe
          src={pdfUrl}
          title={title}
          className="pdf-modal-iframe"
        />
      </div>
    </div>
  </div>
);

const PDFViewer = () => {
  const [modalPdf, setModalPdf] = useState(null);

  const openModal = (pdfUrl, title) => {
    setModalPdf({ pdfUrl, title });
  };

  const closeModal = () => {
    setModalPdf(null);
  };

  const pdfDocuments = [
    {
      url: process.env.PUBLIC_URL + "/pdf/gokurakuji_omote.pdf",
      title: "パンフレット表",
      thumbnailAlt: "極楽寺パンフレット表面"
    },
    {
      url: process.env.PUBLIC_URL + "/pdf/gokurakuji_ura.pdf", 
      title: "パンフレット裏",
      thumbnailAlt: "極楽寺パンフレット裏面"
    }
  ];

  return (
    <div className="pdf-viewer-container">
      <h3 className="pdf-section-title">パンフレット</h3>
      <div className="pdf-thumbnails">
        {pdfDocuments.map((pdf, index) => (
          <div key={index} className="pdf-thumbnail-wrapper">
            <div 
              className="pdf-thumbnail"
              onClick={() => openModal(pdf.url, pdf.title)}
            >
              <iframe
                src={pdf.url}
                title={pdf.thumbnailAlt}
                className="pdf-thumbnail-frame"
                scrolling="no"
              />
              <div className="pdf-overlay">
                <span className="pdf-title">{pdf.title}</span>
                <span className="pdf-click-hint">クリックで拡大</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {modalPdf && (
        <PDFModal 
          pdfUrl={modalPdf.pdfUrl} 
          title={modalPdf.title} 
          onClose={closeModal} 
        />
      )}
    </div>
  );
};

export default PDFViewer;